import { currentUserEmitter } from '../../authUserEmitter';
import { useAuthStore } from '..';

export const emitUserUpdate = () => {
  const user = useAuthStore.getState().user;
  currentUserEmitter.emit('onUserUpdate', { user });
};
